import React, { useMemo } from 'react';
import BookLayout from '../components/BookLayout';
import { books } from '../data/my-books';

function Books() {
  const fireflies = useMemo(() => {
    const small = Array.from({ length: 20 }).map(() => {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const delay = `${(Math.random() * 5).toFixed(2)}s`;
      const duration = `${(3 + Math.random() * 20).toFixed(2)}s`;
      const swirl = Math.random() > 0.6;
      return { top, left, duration, swirl, size: 1 };
    });
    const big = Array.from({ length: 5 }).map(() => {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const delay = `${(Math.random() * 5).toFixed(2)}s`;
      const duration = `${(3 + Math.random() * 4).toFixed(2)}s`;
      const swirl = Math.random() > 0.6;
      return { delay, swirl, size: 2 };
    });
    return [...small, ...big];
  }, []);

  return (
    <section className="hero interior">
      <div className="container">
        <h1>Books by Sean David Robinson</h1>
        
        {books.map((book, index) => (
          <BookLayout key={book.id} {...book} />
        ))}
        
        {/* <div className="retailer-links">
              <h3>Available at:</h3>
              <div className="retailer-buttons">
                <a href="#" className="retailer-btn amazon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M15.93 17.09c-.46.51-1.17.8-1.89.8-.72 0-1.43-.29-1.89-.8-.46-.51-.72-1.2-.72-1.92s.26-1.41.72-1.92c.46-.51 1.17-.8 1.89-.8.72 0 1.43.29 1.89.8.46.51.72 1.2.72 1.92s-.26 1.41-.72 1.92zm-1.89-4.64c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5z"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                  </svg>
                  Amazon
                </a>
                
                <a href="#" className="retailer-btn barnes-noble">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                    <path d="M12 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>
                  </svg>
                  Barnes & Noble
                </a>
                
                <a href="#" className="retailer-btn indiebound">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                  IndieBound
                </a>
                
                <a href="#" className="retailer-btn bookshop">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
                  </svg>
                  Bookshop.org
                </a>
              </div>
            </div> */}
            <div className="retailer-links">
              <h3>Available at all major booksellers on June 23, 2026</h3>
             
            </div>
      </div>
      
      {fireflies.map((pos, idx) => (
        <span
          key={idx}
          className={`firefly${pos.swirl ? ' swirl' : ''}${pos.size === 8 ? ' big' : ''}`}
          style={{
            top: pos.top,
            left: pos.left,
            animationDelay: pos.delay,
            animationDuration: pos.duration,
            opacity: 0.1
          }}
        />
      ))}
    </section>
  );
}

export default Books; 